(() => {
  if (window.equitackVariantAvailability) return;
  window.equitackVariantAvailability = true;
  const selector = 'variant-radios[data-variant-availability], variant-selects[data-variant-availability]';
  const initialized = new WeakSet();

  function initialize(picker) {
    if (initialized.has(picker)) return;
    let config, variants;
    try {
      config = JSON.parse(picker.dataset.variantAvailability);
      variants = JSON.parse(picker.querySelector('script[type="application/json"]').textContent);
    } catch (_) { return; }
    if (!config.enabled || !['hide', 'disable'].includes(config.mode) || variants.length < 2) return;
    const groups = [...picker.querySelectorAll('[data-option-name]')].map(element => {
      const name = element.dataset.optionName.trim().toLocaleLowerCase();
      const category = name === 'size' ? 'size' : ['color', 'colour'].includes(name) ? 'colour' : 'other';
      const select = element.querySelector('select');
      return { element, select, controls: [...element.querySelectorAll('input[type="radio"], option')], applies: config[category] !== false };
    });
    // Incomplete/truncated variant data must not accidentally remove purchasable choices.
    if (!groups.length || !groups.some(g => g.applies) || variants.some(v => !Array.isArray(v.options) || v.options.length !== groups.length)) return;
    if (groups.some((g, index) => g.controls.some(c => !variants.some(v => v.options[index] === c.value)))) return;
    initialized.add(picker);
    const selections = () => groups.map(g => g.select ? g.select.value : g.controls.find(c => c.checked)?.value);
    const available = variants.filter(v => v.available === true);

    function repairSelection(changedIndex = -1) {
      const selected = selections();
      if (available.some(v => v.options.every((value, i) => value === selected[i]))) return false;
      // Keep the changed option, every preceding choice, and every opted-out option.
      // Only later controlled groups may move to complete a purchasable combination.
      const candidates = available.filter(v => v.options.every((value, i) => (i > changedIndex && groups[i].applies) || value === selected[i]));
      candidates.sort((a, b) => b.options.filter((v, i) => v === selected[i]).length - a.options.filter((v, i) => v === selected[i]).length);
      const next = candidates[0];
      if (!next) return false;
      groups.forEach((g, i) => {
        if (g.select) g.select.value = next.options[i];
        else g.controls.forEach(c => { c.checked = c.value === next.options[i]; });
        const selectedLabel = g.element.querySelector('legend span[id^="selected-"]');
        if (selectedLabel) selectedLabel.textContent = ` ${next.options[i]}`;
      });
      return true;
    }

    function apply() {
      const selected = selections();
      groups.forEach((g, index) => {
        if (!g.applies) return;
        g.controls.forEach(control => {
          // Match preceding selections; later controlled groups can be repaired after this choice.
          const purchasable = available.some(v => v.options[index] === control.value && v.options.every((value, i) => i === index || (i > index && groups[i].applies) || value === selected[i]));
          control.disabled = !purchasable;
          control.classList.toggle('disabled', !purchasable);
          const hidden = !purchasable && config.mode === 'hide';
          control.toggleAttribute('data-availability-hidden', hidden);
          control.hidden = hidden;
          const label = control.tagName === 'INPUT' ? control.nextElementSibling : null;
          if (label?.tagName === 'LABEL') {
            label.toggleAttribute('data-availability-hidden', hidden);
            label.hidden = hidden;
          }
          if (g.select) control.textContent = purchasable ? control.value : (window.variantStrings?.unavailable_with_option || '[value] - Unavailable').replace('[value]', control.value);
        });
        // Avoid a stranded heading when hide mode removes every choice (for example, all sold out).
        g.element.toggleAttribute('data-availability-hidden', config.mode === 'hide' && g.controls.every(c => c.hidden));
      });
    }

    // Run before the existing picker change handler, so its normal form, price, URL and media updates
    // receive the final selections. The existing handler and modal/product code are not replaced.
    picker.addEventListener('change', event => {
      const index = groups.findIndex(g => g.element.contains(event.target));
      if (index >= 0) repairSelection(index);
    }, true);
    picker.addEventListener('change', apply);
    picker.addEventListener('click', event => {
      const label = event.target.closest('label');
      if (label?.control?.disabled) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }, true);
    if (repairSelection()) {
      // Use the theme's normal change path for a sold-out deep link or an initially invalid combination.
      const control = groups[0].select || groups[0].controls.find(c => c.checked);
      control?.dispatchEvent(new Event('change', { bubbles: true }));
    }
    apply();
  }

  function scan(root) {
    if (root.matches?.(selector)) initialize(root);
    root.querySelectorAll?.(selector).forEach(initialize);
  }
  Promise.all(['variant-radios', 'variant-selects'].map(name => customElements.whenDefined(name))).then(() => {
    scan(document);
    // Theme Editor section reloads and quick-add content use the same existing picker.
    new MutationObserver(records => records.forEach(record => record.addedNodes.forEach(node => {
      if (node.nodeType === 1) scan(node);
    }))).observe(document.documentElement, { childList: true, subtree: true });
  });
})();
